
import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegisterComponent } from './public/auth/register/register.component';
import { LoginComponent } from './public/auth/login/login.component';
import { LogoutComponent } from './public/auth/logout/logout.component';
import { NewsComponent } from './public/news/news.component';
import { ContactsComponent } from './public/contacts/contacts.component';
import { MemosComponent } from './memos/memos.component';
import { HomeComponent } from './public/home/home.component';
import { NewPasswordComponent } from './public/auth/new-password/new-password.component';
import { RegistrationConfirmationComponent} from "./public/auth/confirm/confirmRegistration.component";
import { ForgotPasswordStep1Component} from "./public/auth/forgot/forgotPasswordStep1.component";
import { ForgotPasswordStep2Component } from "./public/auth/forgot/forgotPasswordStep2.component";
import { AuthGuard } from './service/auth-guard.service';

const appRoutes: Routes = [
  { path: 'kirjaudu', component: LoginComponent },
  { path: 'ulos', canActivate: [AuthGuard], component: LogoutComponent },
  { path: 'rekisteroidy', component: RegisterComponent },
  { path: 'uusi-salasana', component: NewPasswordComponent },
  { path: 'etusivu', component: HomeComponent },
  { path: 'uutiset', component: NewsComponent },
  { path: 'yhteystiedot', component: ContactsComponent },
  { path: 'poytakirjat', canActivate: [AuthGuard], component: MemosComponent },
  { path: 'vahvista', component: RegistrationConfirmationComponent },
  { path: 'unohtunutSalasana/:email', component: ForgotPasswordStep2Component},
  { path: 'unohtunutSalasana', component: ForgotPasswordStep1Component},
  { path: '', redirectTo: 'etusivu', pathMatch: 'full' }
  //,{ path: '**', component: PageNotFoundComponent }
  
  
];

export const appRoutingProviders: any[] = [
    
];
    
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/app/app.routing.ts